import { ReactNode } from "react";
import FileDownloadButton from "./FileDownloadButton";

// Utility function to extract the file name
export const getFileNameFromBlobUrl = (blobUrl: string): string => {
    if (!blobUrl) return '';

    try {
        const url = new URL(blobUrl);
        const segments = url.pathname.split('/');
        return decodeURIComponent(segments[segments.length - 1]);
    } catch (error) {
        console.error('Invalid URL:', error);
        return '';
    }
}

interface Props {
    title: string;
    fileName: string;
    fileRefId: number;
    icon?: ReactNode;
    disabled?: boolean;
    iconOnly?: boolean;
    className?: string;
    onChange: (success: boolean, error?: string) => void;
}

const FileDownloadComponent = ({
    title,
    fileName,
    fileRefId,
    icon,
    disabled = false,
    iconOnly = false,
    className,
    onChange,
}: Props) => {
    return (
        <div className={`filedownload ${className || ""}`}>
            {!iconOnly && (
                <div className="mb-1">
                    <div className="dataNode-label">{title}</div>
                    <div className="dataNode-text">{fileName}</div>
                </div>
            )}

            <FileDownloadButton
                fileName={fileName}
                fileRefId={fileRefId}
                icon={icon}
                disabled={disabled}
                classNameBtn="btn big circular-button border-0 active-color"
                onChange={onChange}
            />
        </div>
    );
};

export default FileDownloadComponent;
